// @ts-nocheck

/**
 * Set the defaultState
 *
 * @static
 * @param  {Object} state  The actual state
 * @param  {Object} action The action to reduce
 * @return {Object}        Return the new state.
 */
const basketSetDefaultStake = (state, action) => {
  const { lastAmount } = action.payload;
  return {
    ...state,
    defaultStake: lastAmount,
  };
};

export default basketSetDefaultStake;
